/*
 * @description: 强制开始认证-
 * 子账号绑定谷歌认证路由页面
 * @Author: xiaoping.zhang
 * @Date: 2019-08-29 16:13:39
 * @LastEditors: xiaoping.zhang
 * @LastEditTime: 2019-08-29 16:26:52
 */

var route = {
  path: "/subaccountauth",
  getComponent(nextState, cb) {
    require.ensure(
      [],
      require => {
        cb(null, require("../pc/GoogleSafe.jsx").default);
      },
      "subaccountauth"
    );
  }
};

export default route;



// WEBPACK FOOTER //
// ./src/routes/subaccountauth.js